export const orderByName = (obj: any): any => {
  const all = obj.sort((a: any, b: any) => {
    const first = a.name.toLowerCase();
    const second = b.name.toLowerCase();
    if (first < second) return -1
    if (first > second) return 1
    return 0
  });
  return all
}